import styled, { keyframes, css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';

const ContainerLayout = styled.div`
  max-width: 1480px;
  margin: auto;
  margin-top: ${({ portalWithTelBanner }) => (portalWithTelBanner ? 30 : 0)}px;
  display: flex;
  gap: 40px;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex-direction: column;
      padding: 16px;
    `}
  margin-top: ${({ portalWithTelBanner, isDesktop, inDesempeno }) => {
    if (isDesktop && inDesempeno) return 0;
    return portalWithTelBanner ? '70' : '30';
  }}px;
  ${withQuery.lg.down()} {
    margin-top: ${({ portalWithTelBanner, isDesktop, inDesempeno }) => {
      if (isDesktop && inDesempeno) return 0;
      return portalWithTelBanner ? '110' : '70';
    }}px;
  }
  ${({ inDesempeno }) =>
    inDesempeno &&
    css`
      padding: 16px 0 0 0;
      margin-top: 0px;
      gap: 0px;
      width: 100%;
    `}
`;

const LeftSide = styled.div`
  width: 290px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      width: 100%;
    `}
  @media screen and (max-width: 1530px) {
    margin-left: ${({ isDesktop }) => (!isDesktop ? 0 : 16)}px;
  }
`;

const RightSide = styled.div`
  width: ${({ inDesempeno }) => (inDesempeno ? 100 : 80)}%;
  margin-bottom: 50px;
  > .multiGraph {
    margin-top: 24px;
    display: flex;
    gap: 40px;
    ${({ device }) =>
      device === 'mobile' &&
      css`
        flex-direction: column;
      `}
  }
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      width: 100%;
    `}
  @media screen and (max-width: 1530px) {
    margin-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
`;

const CompanyInfo = styled.div`
  padding: 14px;
  border-radius: 8px;
  border: 1px solid ${select('middleGray')};
  display: flex;
  > section {
    margin-left: 14px;
  }
`;

const Logo = styled.div`
  width: 91px;
  height: 50px;
  background-color: ${select('lightGray')};
  border-radius: 8px;
`;

const Tabs = styled.div`
  height: 180px;
  border-radius: 12px;
  background-color: ${select('lightGray')};
`;

const Header = styled.div`
  margin-bottom: ${({ inDesempeno }) => (inDesempeno ? '8' : '35')}px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex-direction: column;
      margin-bottom: 30px;
    `}
`;

const withBorder = css`
  border: 1px solid ${select('middleGray')};
  border-radius: 8px;
`;

const DateSelector = styled.div`
  width: 170px;
  height: 49px;
  background: ${select('lightGray')};
  border: 1px solid ${select('middleGray')};
  border-radius: 18px;
  margin-bottom: 10px;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      width: 100%;
      margin-top: 40px;
    `}
`;

const LeadsComparisonGraph = styled.div`
  ${withBorder}
  padding: 24px;
  > section {
    ${({ isDesktop }) =>
      isDesktop
        ? css`
            margin-bottom: 40px;
            display: flex;
          `
        : css`
            > div {
              margin-bottom: 70px;
            }
            div:last-child {
              margin-bottom: 0px;
            }
          `}

    justify-content: space-between;
  }
`;

const LeadCard = styled.div`
  display: flex;
  > section {
    margin-left: 12px;
  }
`;

const TabsSection = styled.div`
  display: flex;
  margin-bottom: 40px;
  > div {
    margin-right: 16px;
  }
`;

const GraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  > div {
    margin-bottom: 25px;
    margin-top: 20px;
  }
`;

const ConversionGraph = styled.div`
  ${withBorder}
  padding: 24px;
  flex: 2;
  > section {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  > .imgContainer {
    height: 80%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      max-width: 80%;
      ${({ isDesktop }) =>
        !isDesktop &&
        css`
          max-width: 100%;
        `}
    }
  }
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex: 1;
    `}
`;

const ByTypeGraph = styled.div`
  ${withBorder}
  padding: 24px;
  flex: 1;
  > section {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

const Circle = styled.div`
  height: ${({ height }) => height || '159px'};
  width: ${({ width }) => width || '159px'};
  border-radius: 50%;
  background: ${select('lightGray')};
  display: flex;
  margin: auto;
`;

const CircleRef = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 10px;
  > .ref-point {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: ${select('lightGray')};
  }
`;

const Refs = styled.div``;

const BackgroundGradient = css`
  background: linear-gradient(
    90deg,
    #e7eef0 0%,
    #f3f7f8 23.66%,
    rgba(250, 251, 252, 0.489237) 45.78%,
    #f2f6f7 78.19%,
    #e7eef0 98.76%
  );
`;

const animationDuration = '4s';

const ShineLines = keyframes`
  0% { background-position: -200px };
  100% { background-position: 350px};
`;

export const animationLine = css`
  animation: ${ShineLines} ${({ isCircular }) => (isCircular ? '12s' : animationDuration)} infinite linear;
`;

const LineContent = styled.div`
  ${BackgroundGradient};
  height: ${({ height }) => height || '16px'};
  width: ${({ width }) => width};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-right: ${({ marginRight }) => marginRight};
  border-radius: ${({ isCircular }) => (isCircular ? '50%' : '8px')};
  ${animationLine};
  ${animationLine};
`;

const LineContainer = styled.div`
  display: flex;
  width: ${({ width }) => width || '100%'};
  justify-content: space-between;
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;

const CardContent = styled.div`
  display: flex;
  margin-top: 30px;
  gap: 40px;
  min-height: ${({ minHeight }) => minHeight};
  padding: 24px;
  .mobile-title-container {
    display: flex;
    justify-content: center;
  }
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .star-section {
      display: flex;
      gap: 16px;
      align-items: center;
      .stars-container {
        display: flex;
        gap: 12px;
        margin-bottom: 8px;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    .block-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 12px;
      .graph-container {
        display: flex;
        gap: 12px;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
      }
      ${({ isMobile }) =>
        isMobile &&
        css`
          flex-direction: row;
          margin-bottom: 20px;
        `}
    }
  }
  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-direction: column;
      .fist-section {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 25px;
        .star-section {
          display: flex;
        }
      }
    `}
`;

const Separator = styled.div`
  width: 1px;
  height: ${({ h }) => h || '128'}px;
  background-color: ${select('middleGray')};
`;

const HorizontalSeparator = styled.div`
  height: 1px;
  width: ${({ w }) => `${w}px` || '100%'};
  background-color: ${select('middleGray')};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-top: ${({ marginTop }) => marginTop};
`;

const CardHeader = styled.div`
  > div {
    display: flex;
    align-items: center;
    gap: 11px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SimpleCircle = styled.div`
  width: ${({ w }) => w || '0'}px;
  height: ${({ h }) => h || '0'}px;
  border-radius: 50%;
  ${BackgroundGradient};
  ${animationLine};
`;

const GraphBar = styled.div`
  width: 100%;
  border-radius: 8px;
  height: 8px;
  background-color: ${select('lightGray')};
  max-width: 500px;
`;

const CardContentCalifications = styled(CardContent)`
  .left {
    flex-direction: row;
    gap: 16px;
    align-items: center;
    .label-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      ${({ isMobile }) =>
        isMobile &&
        css`
          align-items: center;
        `}
    }
  }
`;

const CardContentReports = styled(CardContent)`
  align-items: center;
  .right {
    .right-top {
      display: flex;
      justify-content: center;
      .ball-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-height: 160px;
      }
    }
    .graph-label {
      display: flex;
      gap: 26px;
      justify-content: center;
    }
  }
  .left {
    .left-top {
      display: flex;
      justify-content: center;
      gap: 30px;
      margin-bottom: 32px;
      .pair {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
      }
    }
  }
  .last-section {
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

const GhaphImgContainer = styled.div``;

const ScoreSection = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  gap: 8px;
`;

const LineDiv = styled.div`
  width: 100%;
  border-top: 1px solid #e7eef0;
  margin-bottom: 16px;
`;

const ScoreContainer = styled.div`
  margin-bottom: 16px;
`;

const Secondary = styled.button`
  display: flex;
  width: 184px;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  color: ${({ disabled }) => (disabled === true ? '#C8C8C8' : '')};
  border: ${({ disabled }) => (disabled === true ? '1px solid #C8C8C8' : '1px solid #ff5500')};
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
  }
  :hover {
    background: ${({ disabled }) => (disabled === true ? '' : '#FFE8DC')};
  }
`;

const ButtonDiv = styled.div`
  text-align: right;
  font-family: 'Hind';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  height: 48px;
`;

export {
  ContainerLayout,
  LeftSide,
  CompanyInfo,
  Tabs,
  RightSide,
  Header,
  DateSelector,
  LeadsComparisonGraph,
  ConversionGraph,
  ByTypeGraph,
  LineContent,
  LineContainer,
  Logo,
  LeadCard,
  TabsSection,
  GraphContainer,
  Circle,
  CircleRef,
  Refs,
  CardContent,
  CardHeader,
  SimpleCircle,
  Separator,
  GraphBar,
  CardContentCalifications,
  CardContentReports,
  GhaphImgContainer,
  HorizontalSeparator,
  ScoreSection,
  LineDiv,
  ScoreContainer,
  Secondary,
  ButtonDiv
};
